import { useSelector } from 'react-redux'
import { INACTIVE } from 'settings/_planStatusSettings'
import { TVTVPACI } from 'settings/_profileSettings'

interface Schedule {
  planCode: string
}

interface EligibleToSchedule {
  eligibleToSchedule: boolean
}

interface RootState {
  auth: {
    userData: {
      person_profile: Array<{
        profile_code: string
        plans: Array<{
          partner_plan_code: string
          eligible_to_schedule: boolean | null
          status_name: string
        }>
      }>
    }
  }
}

export function useEligibleToSchedule(nextSchedule: Schedule): EligibleToSchedule {
  const userData = useSelector((state: RootState) => state.auth.userData)
  const profiles = userData.person_profile
  const patientProfile = profiles.find((profile) => profile.profile_code === TVTVPACI)
  const patientPlans = patientProfile?.plans
  const plan = patientPlans.find((plan) => plan.partner_plan_code === nextSchedule.planCode && plan.status_name !== INACTIVE)

  function handleEligibleToSchedule(eligibleToSchedule: boolean | null): boolean {
    if (eligibleToSchedule === null || eligibleToSchedule === true) {
      return true
    } else {
      return false
    }
  }

  const eligibleToSchedule = handleEligibleToSchedule(plan?.eligible_to_schedule)

  return { 
    eligibleToSchedule 
  }
}